import React, { Component } from "react";
import { TextInput, ValidationForm } from "react-bootstrap4-form-validation";
import Spinner from 'react-bootstrap/Spinner';
import * as EmailValidator from 'email-validator';
import { logEvent } from '../analytics'

class Subscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            message: "",
            loading: false,
            success: false,
            error: false,
            successMsg: "Thanks for contacting us! We'll be in touch shortly.",
            errorMsg: "",
        };
    }

    handleFields = e => this.setState({ [e.target.name]: e.target.value });

    sendEmail = async (e) => {
        e.preventDefault();
        const { name, email, message } = this.state;

        if (!name || !email || !message) {
            this.setState({
                error: true,
                success: false,
                errorMsg: "Please fill in all fields."
            });
            return;
        }

        // Email validation
        if (!EmailValidator.validate(email)) {
            this.setState({
                error: true,
                success: false,
                errorMsg: "Please enter a valid email address."
            });
            return;
        }

        this.setState({ loading: true, error: false });

        try {
            const formData = new FormData();
            formData.append("name", name);
            formData.append("email", email);
            formData.append("message", message);

            const res = await fetch("https://getform.io/f/bdrnznnb", {
                method: "POST",
                body: formData
            });

            if (res.ok) {
                logEvent("Contact Form", "Submit", "Successful contact form submission");
                this.setState({
                    loading: false,
                    success: true,
                    error: false,
                    name: "",
                    email: "",
                    message: ""
                });
            } else {
                this.setState({ loading: false, error: true });
                console.error("Failed submission:", res.statusText);
            }
        } catch (err) {
            console.error("Error submitting form:", err);
            this.setState({ loading: false, error: true });
        }
    };

    displaySuccessMessage = () => {
        if (this.state.success) {
            return <h6 className="body2" style={{ color: 'white', paddingTop: 20 }}>{this.state.successMsg}</h6>;
        } else if (this.state.error) {
            return <h6 className="body2" style={{ color: '#FFB300', paddingTop: 20 }}>{this.state.errorMsg}</h6>;
        }
        return null;
    };

    render() {
        return (
            <React.Fragment>
                <section id='estimate' className="subscribe-area ptb-100">
                    <div className="container subscribe-container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6">
                                <h2 style={{ textAlign: 'left', color: 'white', maxWidth: '320px' }}>
                                    Ready to kick start your project?
                                </h2>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="main-banner-form">
                                    <ValidationForm onSubmit={this.sendEmail}>
                                        <div className="form-group">
                                            <TextInput
                                                name="name"
                                                id="name"
                                                className="form-control"
                                                placeholder="Your Name"
                                                autoComplete="off"
                                                onChange={this.handleFields}
                                                value={this.state.name}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <TextInput
                                                name="email"
                                                id="email"
                                                type="text"
                                                className="form-control"
                                                placeholder="Your Email"
                                                autoComplete="off"
                                                onChange={this.handleFields}
                                                value={this.state.email}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <TextInput
                                                name="message"
                                                id="description"
                                                multiline
                                                placeholder="Project details..."
                                                className="form-control"
                                                rows="6"
                                                autoComplete="off"
                                                onChange={this.handleFields}
                                                value={this.state.message}
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            disabled={this.state.loading}
                                            className="btn subscribe-button body5 bold"
                                        >
                                            {
                                                this.state.loading ?
                                                    <Spinner as="span" animation="border" role="status" aria-hidden="true" />
                                                    : 'Send'
                                            }
                                        </button>

                                        {this.displaySuccessMessage()}
                                    </ValidationForm>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Subscribe;
